import { IpService } from './../shared/services/ip.service';
import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd } from '@angular/router';

import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from './icons/icon-subset';
import { filter } from 'rxjs/operators';

const TITLE_MAP: Record<string, string> = {
  '/search/search-global': 'ICD Smart Search',
  '/search/query-global': 'ICD Smart Search',
  '/notification/notification-list': 'Có gì mới',
  '/dashboard/ucod': 'Dashboard UCOD',
  '/dashboard/mccd': 'Dashboard MCCD',
  '/tools/ucod': 'UCOD Việt Nam',
  '/tools/drg': 'DRG Việt Nam',
  '/icd-9/icd9': 'ICD-9',
  '/icd-9/icd9-dual': 'ICD-9 Dual',
  '/icd-9/instruction-icd9': 'ICD-9 Instruction',
  '/icd-10/icd10': 'ICD-10',
  '/icd-10/icd10-dual': 'ICD-10 Dual',
  '/icd-10/instruction-icd10': 'ICD-10 Instruction',
  '/icd-10/icd10v3': 'ICD10 v3',
  '/icd-10-tt06/icd10-tt06': 'ICD-10 06/2026/TT-BYT',
  '/icd-10-tt06/icd10-tt06-dual': 'ICD-10 06/2026/TT-BYT Dual',
  '/icf/icf': 'ICF',
  '/icf/icf-dual': 'ICF Dual',
  '/icf/instruction-icf': 'ICF - Instruction',
  '/loinc-table': 'LOINC Table',
  '/emr-form': 'EMR Form',
  '/yhct/yhct-7603': 'DM Bệnh YHCT (7603/QĐ-BYT)',
  '/yhct/yhct-1978': 'DM Bệnh YHCT (1978/QĐ-BYT)',
  '/chatbot/icd-10': 'ICD-10 Sense',
  '/chatbot/icd-9': 'ICD-9 Sense',
  '/chatbot/icf': 'ICF Sense',
};

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private titleService: Title,
    private iconSetService: IconSetService,
    private ipService: IpService
  ) {
    // iconSet singleton
    iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter((evt): evt is NavigationEnd => evt instanceof NavigationEnd),
    ).subscribe(evt => {
      const url = evt.urlAfterRedirects.split('?')[0];
      const title = TITLE_MAP[url] || '';
      this.titleService.setTitle(title ? `${title} | CCMS` : 'CCMS');
    });

    this.ipService.getClientIp().subscribe(
      (data: any) => {
        const clientIp = data.ip;
        localStorage.setItem('client_ip', clientIp);
      },
      (error) => {
        console.log('Error while fetching client IP:', error);
      }
    );
  }
}
